import { render, staticRenderFns } from "./ChatLayout.vue?vue&type=template&id=1c3e7a96&scoped=true"
import script from "./ChatLayout.vue?vue&type=script&lang=js"
export * from "./ChatLayout.vue?vue&type=script&lang=js"
import style0 from "./ChatLayout.vue?vue&type=style&index=0&id=1c3e7a96&prod&scoped=true&lang=css"
import style1 from "./ChatLayout.vue?vue&type=style&index=1&id=1c3e7a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3e7a96",
  null
  
)

export default component.exports